import Duck from 'extensible-duck';

import { DUCKS_NAMESPACE } from '../config/constants';

export default new Duck({
  namespace: DUCKS_NAMESPACE,
  store: 'virtualTransactionJson',
  initialState: {
    isShowVirtualTransactionJsonModal: false,
    virtualTransaction: null,
  },

  types: ['SHOW_VIRTUAL_TRANSACTION_MODAL', 'HIDE_VIRTUAL_TRANSACTION_MODAL'],

  reducer: (state, action, { types, initialState }) => {
    switch (action.type) {
      case types.SHOW_VIRTUAL_TRANSACTION_MODAL:
        return {
          ...state,
          ...action.payload,
          isShowVirtualTransactionJsonModal: true,
        };
      case types.HIDE_VIRTUAL_TRANSACTION_MODAL:
        return { ...state, isShowVirtualTransactionJsonModal: false };
      default:
        return state;
    }
  },

  creators: ({ types }) => ({
    showVirtualTransactionJsonDialog: ({ virtualTransaction }) => ({
      type: types.SHOW_VIRTUAL_TRANSACTION_MODAL,
      payload: {
        virtualTransaction,
      },
    }),
    hideVirtualTransactionJsonDialog: () => ({
      type: types.HIDE_VIRTUAL_TRANSACTION_MODAL,
    }),
  }),
});
